import { AuthSubscriptions } from '@hefe/auth';
import { t } from '@hefe/i18n';
import { BasketballTeam, SelectOption } from '@hefe/models';
import { currentUserSelector } from '@hefe/store';
import { clubHasSubscription } from '@hefe/utils';
import { Card, Col, Row, Tabs, Tooltip } from 'antd';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import EditTeamForm from '../../../forms/edit-team/edit-team.form';
import TeamPlayersComponent from '../team-players/team-players.component';
import TeamPracticeTimesComponent from '../team-practice-times/team-practice-times.component';

interface TeamSettingsComponentProps {
  team: BasketballTeam;
  coaches: SelectOption[];
}

export default function TeamSettingsComponent(
  props: TeamSettingsComponentProps
) {
  const user = useSelector(currentUserSelector);

  const { coaches, team } = props;

  const tabs = useMemo(() => {
    const returnValue = [];

    returnValue.push({
      key: 'settings',
      label: t('settings.title'),
      children: <EditTeamForm team={team} coaches={coaches} />,
    });

    const practiceTimesAllowed = clubHasSubscription(
      AuthSubscriptions.first,
      user
    );

    returnValue.push({
      key: 'practice_times',
      label: practiceTimesAllowed ? (
        t('practice_times')
      ) : (
        <Tooltip title={t('errors.permissions.first')}>
          <span>{t('practice_times')}</span>
        </Tooltip>
      ),
      disabled: !practiceTimesAllowed,
      children: <TeamPracticeTimesComponent team={team} />,
    });

    returnValue.push({
      key: 'players',
      label: t('players'),
      children: <TeamPlayersComponent team={team} />,
    });

    return returnValue;
  }, [team, coaches, user]);

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24}>
        <Card>
          <Tabs items={tabs} />
        </Card>
      </Col>
    </Row>
  );
}
